import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IndexLink, Link, browserHistory } from 'react-router';
import InlineSVG from 'svg-inline-react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Snackbar from 'material-ui/Snackbar';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import Divider from 'material-ui/Divider';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import SelectField from 'material-ui/SelectField';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import IconChecked from '../../assets/checked.svg';

import classes from './Header.scss';
import mergeStates from '../../helpers/mergeStates';
import Logo from '../../assets/logo.svg';
import IconSidebar from '../../assets/ic-sidebar.svg';
import IconSupport from '../../assets/ic-support.svg';
import NotificationList from '../NotificationList/NotificationList';
import FormSettings from '../FormSettings/FormSettings';

import {
  toggleSideBar,
  toggleCompactMode,
  runJoyride,
} from '../../store/modules/options';
import { logout, switchAccount } from '../../store/modules/login';
import { submitSupportTicket } from '../../store/modules/support';
import { addFeedback } from '../../store/modules/feedback';
import { simplAvatarUrl } from '../../api/simplApi';
import JoyRideHeader from '../JoyRideHeader/JoyRideHeader';

import moment from 'moment';

const mapActionCreators = {
  toggleSideBar,
  toggleCompactMode,
  logout,
  switchAccount,
  submitSupportTicket,
  addFeedback,
  runJoyride,
};

const mapStateToProps = state => ({
  open: state.options.sidebarOpen,
  compactMode: state.options.compactMode,
  login: state.login,
  notificationFetching: state.notification.fetching,
  notifications: state.notification.notifications,
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supportFormOpen: false,
      feedbackSent: false,
      userMenuOpen: false,
      switcherOpen: false,
      settingsOpen: false,
      feedback: {
        about: 'Allgemein',
        type: 'question',
        message: '',
      },
    };

    if (props.login.token === null) {
      if (
        `${window.location.origin}/` !== `${window.location.href}` &&
        window.location.href.indexOf('password/reset') === -1
      ) {
        // console.log('should redirect to login');
        this.props.addFeedback('error', 'token missing');

        window.location = window.location.origin;
      }
    }
  }

  openSettings = event => {
    if (typeof event !== 'undefined') {
      event.preventDefault();
    }

    this.setState({
      settingsOpen: true,
    });
  };

  closeSettings = event => {
    if (typeof event !== 'undefined') {
      event.preventDefault();
    }

    this.setState({
      settingsOpen: false,
    });
  };

  openUserMenu = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      userMenuOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  closeUserMenu = () => {
    this.setState({
      userMenuOpen: false,
    });
  };

  openSwitcherMenu = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      switcherOpen: true,
      anchorElSwitcher: event.currentTarget,
    });
  };

  closeSwitcherMenu = () => {
    this.setState({
      switcherOpen: false,
    });
  };

  handleSupportFormOpen = () => {
    // console.log('Opening support form...');
    this.setState({ supportFormOpen: true });
  };

  handleSupportFormClose = () => {
    // console.log('Closing support form...');
    this.setState({ supportFormOpen: false });
  };

  submitSupportForm = () => {
    if (this.state.feedbackSent !== false) {
      // console.log('Feedback form already sent!');
      return;
    }

    // console.log('Trying to submit support form...');

    const feedbackSent = true;
    this.setState({ feedbackSent });

    this.props.submitSupportTicket(this.state.feedback);
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    // console.log(nextState);
    this.setState(nextState);
    // this.props.onChange(nextState);
  };

  handleSupportAboutChange = value => {
    const nextState = mergeStates(null, this.state, 'feedback.about', value);
    // console.log(nextState);
    this.setState(nextState);
  };

  handleSupportFormSuccessClose = () => {
    const feedbackSent = false;
    this.setState({ feedbackSent });

    const feedback = {
      about: 'Allgemein',
      type: 'question',
      message: '',
    };

    this.setState({ feedback });
  };

  renderSupportFormFields = () => {
    const textareaLabels = {
      question: 'Meine Frage ist',
      bug: 'Der Fehler ist',
      mobile: 'Mein Feedback',
      feedback: 'Mein Feedback',
      thanks: 'Ich danke für',
    };
    return (
      <div className="header">
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label">Ich möchte</label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <RadioButtonGroup
              name="feedback.type"
              defaultSelected="question"
              onChange={(event, val) => this.handleChange(event)}
            >
              <RadioButton
                value="question"
                label="eine Frage stellen"
                className={classes.radioButton}
              />
              <RadioButton
                value="bug"
                label="einen Fehler melden"
                className={classes.radioButton}
              />
              <RadioButton
                value="feedback"
                label="Feedback liefern"
                className={classes.radioButton}
              />
              <RadioButton
                value="thanks"
                label="Danke sagen"
                checkedIcon={<ActionFavorite style={{ color: '#4a90e2' }} />}
                uncheckedIcon={<ActionFavoriteBorder />}
                className={classes.radioButton}
              />
              <RadioButton
                value="mobile"
                label="einen Fehler zur iPhone/Android App melden"
                className={classes.radioButton}
              />
            </RadioButtonGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label">Es geht um</label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <SelectField
              name="feedback.about"
              value={this.state.feedback.about}
              onChange={(event, index, value) =>
                this.handleSupportAboutChange(value)
              }
            >
              <MenuItem value="Allgemein" primaryText="Allgemein" />
              <MenuItem value="Aktivitäten" primaryText="Aktivitäten" />
              <MenuItem value="Projekte" primaryText="Projekte" />
              <MenuItem value="Unternehmen" primaryText="Unternehmen" />
              <MenuItem value="Mitarbeiten" primaryText="Mitarbeiter" />
              <MenuItem value="Sonstiges" primaryText="Sonstiges" />
            </SelectField>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label">
              {textareaLabels[this.state.feedback.type]}
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <textarea
              name="feedback.message"
              rows="3"
              onChange={this.handleChange}
            />
          </div>
        </div>

        <hr />

        <p className="quiet">
          Unser Team ist ständig im Einsatz und bemüht sich, so schnell wie
          möglich Ihnen zu antworten. Wir bearbeiten Supportanfragen
          durchschnittlich innerhalb von 2-3 Werktagen.
        </p>
      </div>
    );
  };
  renderSupportForm = () => {
    const title = (
      <span className={classes.feedbackHeader}>
        <span alt="Support" aria-label="Support Anfragen">
          <InlineSVG
            src={IconSupport}
            className={classes.feedbackIcon}
            alt="Support"
            aria-label="Support Anfragen"
          />
        </span>
        Support/Feedback
      </span>
    );
    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.handleSupportFormClose();
        }}
      />,
      <FlatButton
        label="Senden"
        primary
        onMouseDown={() => this.submitSupportForm()}
        disabled={this.state.feedback.message.length < 10}
      />,
    ];
    const styles = {
      wrapper: {
        padding: 24,
      },
    };
    return (
      <div>
        <Dialog
          title={title}
          actions={!this.state.feedbackSent ? actions : []}
          modal={false}
          open={this.state.supportFormOpen}
          onRequestClose={this.handleSupportFormClose}
          autoScrollBodyContent
          className="form"
          contentClassName="form-container form-container--feedback"
          titleClassName="form-header"
          actionsContainerClassName="form-footer"
          bodyClassName="form-body form-body-tabbed"
        >
          <div style={styles.wrapper}>
            {this.state.feedbackSent ? '' : this.renderSupportFormFields()}
          </div>
        </Dialog>
        <Snackbar
          open={this.state.feedbackSent}
          message="Vielen Dank für Ihre Nachricht! Wir melden uns so schnell wie möglich :)"
          autoHideDuration={4000}
          onRequestClose={this.handleSupportFormSuccessClose}
        />
      </div>
    );
  };

  renderCompanySwitcher = () => {
    let companySwitcher = null;
    if (
      typeof this.props.login.simplAccounts !== 'undefined' &&
      this.props.login.simplAccounts.length > 1
    ) {
      const accountList = [];
      let checkmark = '';
      _.forOwn(this.props.login.simplAccounts, data => {
        let cssClass = '';
        let note = null;
        if (this.props.login.user.current_simpl_account === data.id) {
          checkmark = <InlineSVG src={IconChecked} />;
          cssClass = classes.active;

          if (
            typeof data.deactivated_at !== 'undefined' &&
            data.deactivated_at !== null
          ) {
            const deactivationDate = moment(data.deactivated_at).format(
              'dddd, D. MMMM Y [um] HH:mm [Uhr]',
            );
            note = (
              <span className={classes.accountNote}>
                (wird am {deactivationDate} deaktiviert)
              </span>
            );
          }
        } else {
          checkmark = null;
        }

        accountList.push(
          <div
            key={`switch_account_${data.id}`}
            className={`${classes.menuItem} ${cssClass}`}
            onClick={() => {
              this.closeUserMenu();
              this.props.switchAccount(data.id);
            }}
          >
            {data.name} {checkmark} {note}
          </div>,
        );
      });
      companySwitcher = (
        <div>
          <div className={classes.menuHeader}>Unternehmen wechseln</div>
          {accountList}
          <Divider />
        </div>
      );
    }

    return companySwitcher;
  };

  renderMenuPoints = () => (
    <ul className={classes.menuPoints}>
      <li>
        <Link
          to="/activity"
          activeClassName={classes.activeRoute}
          className="joyRideHeaderActivity"
        >
          Aktivitäten
        </Link>
      </li>
      <li>
        <Link to="/company" activeClassName={classes.activeRoute}>
          Unternehmen
        </Link>
      </li>
      <li>
        <Link to="/project" activeClassName={classes.activeRoute}>
          Projekte
        </Link>
      </li>
      <li>
        <Link to="/person" activeClassName={classes.activeRoute}>
          Kontakte
        </Link>
      </li>
      <li>
        <Link to="/staff" activeClassName={classes.activeRoute}>
          Mitarbeiter
        </Link>
      </li>
      <li>
        <Link to="/file" activeClassName={classes.activeRoute}>
          Dateien
        </Link>
      </li>
    </ul>
  );

  renderAdminMenu = () => {
    if (this.props.login.amIAdmin === false) {
      return null;
    } else {
      return (
        <div>
          <div className={classes.menuHeader}>Administration</div>

          <div
            className={classes.menuItem}
            onClick={() => {
              this.closeUserMenu();
              browserHistory.push(`/company/${this.props.login.myCompany.id}`);
            }}
          >
            Unternehmen anzeigen
          </div>

          <div
            className={classes.menuItem}
            onClick={() => {
              this.closeUserMenu();
              browserHistory.push('/numberrange');
            }}
          >
            Nummernkreise
          </div>

          <div
            className={classes.menuItem}
            onClick={() => {
              this.closeUserMenu();
              browserHistory.push('/serviceKey');
            }}
          >
            Leistungskategorien
          </div>

          <div
            className={classes.menuItem}
            onClick={() => {
              this.closeUserMenu();
              browserHistory.push('/recovery');
            }}
          >
            Datenrettung
          </div>

          <Divider />
        </div>
      );
    }
  };

  renderLoginButton = () => {
    if (!this.props.login.isAuthenticated) {
      return (
        <li className={classes.avatar}>
          <Link to="/login">Log In</Link>
        </li>
      );
    }

    const avatar = simplAvatarUrl(
      'staff',
      this.props.login.staff.id,
      128,
      128,
      'crop',
    );

    return (
      <li
        className={`${classes.avatar} joyRideHeaderUser`}
        data-tip="Ihre SiMPL Einstellungen"
        onClick={this.openUserMenu}
      >
        <span>
          <img src={avatar} alt="" width={24} height={24} />
        </span>
        <Popover
          open={this.state.userMenuOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            horizontal: window.innerWidth < 767 ? 'right' : 'left',
            vertical: window.innerWidth < 767 ? 'bottom' : 'bottom',
          }}
          targetOrigin={{
            horizontal: window.innerWidth < 767 ? 'right' : 'left',
            vertical: window.innerWidth < 767 ? 'top' : 'top',
          }}
          onRequestClose={this.closeUserMenu}
        >
          <Menu className={classes.userMenuList}>
            {this.renderCompanySwitcher()}

            {this.renderAdminMenu()}

            <div className={classes.menuHeader}>Profil</div>

            <div
              className={classes.menuItem}
              onClick={() => {
                this.closeUserMenu();
                browserHistory.push(`/staff/${this.props.login.staff.id}`);
              }}
            >
              Mein Profil anzeigen
            </div>

            <div
              className={classes.menuItem}
              onClick={event => {
                this.closeUserMenu();
                this.openSettings(event);
              }}
            >
              Profileinstellungen
            </div>

            <div
              className={classes.menuItem}
              onClick={this.props.toggleCompactMode}
            >
              Kompaktmodus de-/aktivieren
            </div>

            <Divider />

            <div
              className={classes.menuItem}
              onClick={() => {
                this.closeUserMenu();
                this.handleSupportFormOpen();
              }}
            >
              Hilfe & Support
            </div>

            <div
              className={classes.menuItem}
              onClick={() => {
                this.closeUserMenu();
                this.props.runJoyride();
              }}
            >
              Tutorial de-/aktivieren
            </div>

            <Divider />

            <div
              className={classes.menuItem}
              onClick={() => {
                this.closeUserMenu();
                this.props.logout();
              }}
            >
              Abmelden
            </div>

            {/* <Divider /> */}

            {/* <Limits /> */}
          </Menu>
        </Popover>
      </li>
    );
  };

  render() {
    let headerClass = `${classes.header} ${classes.loggedOut}`;

    if (this.props.login.isAuthenticated) {
      headerClass = classes.header;

      if (this.props.open) {
        headerClass = `${headerClass} ${classes.openSidebar}`;
      }
    }

    const sidebarClass = this.props.open
      ? `${classes.sidebarToggle} ${classes.sidebarToggleOpen}`
      : classes.sidebarToggle;
    const settings = this.state.settingsOpen ? (
      <FormSettings onClose={this.closeSettings} />
    ) : null;
    return (
      <header className={headerClass}>
        <div className={classes.content}>
          <IndexLink to="/dashboard" activeClassName={classes.activeRoute}>
            <InlineSVG src={Logo} className={classes.logo} />
          </IndexLink>
          <nav className={`${classes.nav} hidden-phone`}>
            {this.renderMenuPoints()}
          </nav>
          <nav className={`${classes.usermenu}`}>
            <div className={`${classes.companyName} hidden-phone`}>
              {this.props.login.myCompany.name}
            </div>
            <ul>
              <li
                className={`${classes.mobileMenuButtonWrapper} hidden-desktop`}
              >
                <IconMenu
                  iconButtonElement={
                    <IconButton className={classes.mobileMenuButton}>
                      <MoreVertIcon />
                      <span>Menü</span>
                    </IconButton>
                  }
                  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                  {this.renderMenuPoints()}
                </IconMenu>
              </li>
              <NotificationList />
              {this.renderLoginButton()}

              <li
                onClick={this.props.toggleSideBar}
                className={`${sidebarClass} joyRideHeaderSidebar`}
                data-tip="Sidebar ein-/ausblenden"
              >
                <InlineSVG src={IconSidebar} className={classes.iconSidebar} />
              </li>
            </ul>
          </nav>
        </div>
        {this.renderSupportForm()}
        {settings}
        <JoyRideHeader />
      </header>
    );
  }
}
Header.propTypes = {
  login: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  toggleCompactMode: PropTypes.func.isRequired,
  switchAccount: PropTypes.func.isRequired,
  addFeedback: PropTypes.func.isRequired,
  runJoyride: PropTypes.func.isRequired,
  open: PropTypes.bool,
  compactMode: PropTypes.bool,
  submitSupportTicket: PropTypes.func.isRequired,
};
Header.defaultProps = {
  login: {
    token: null,
    user: {},
    staff: {},
  },
};
export default connect(mapStateToProps, mapActionCreators)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js